import { render } from "./Question2.vue?vue&type=template&id=3515b68d&scoped=true"
import script from "./Question2.vue?vue&type=script&lang=js"
export * from "./Question2.vue?vue&type=script&lang=js"

import "./Question2.vue?vue&type=style&index=0&id=3515b68d&lang=scss&scoped=true"
import "./Question2.vue?vue&type=style&index=1&id=3515b68d&lang=scss"

import exportComponent from "/codebuild/output/src1728185854/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3515b68d"]])

export default __exports__